import { useId } from 'react'

interface FileTypeIconProps {
  fileType: string
  className?: string
}

function PdfIcon({ prefix }: { prefix: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 100" className="w-full h-full">
      <linearGradient
        id={`${prefix}-a`}
        gradientUnits="userSpaceOnUse"
        x1="36"
        y1=".767"
        x2="36"
        y2="99.25"
        gradientTransform="matrix(1 0 0 -1 0 100)"
      >
        <stop offset=".005" stop-color="#6e0e10" />
        <stop offset=".047" stop-color="#7e1416" />
        <stop offset=".116" stop-color="#94191c" />
        <stop offset=".196" stop-color="#a71d21" />
        <stop offset=".289" stop-color="#b61f24" />
        <stop offset=".403" stop-color="#c02026" />
        <stop offset=".563" stop-color="#c72027" />
        <stop offset="1" stop-color="#c82127" />
      </linearGradient>
      <path d="M45 .8l27 26.9v71.6H0V.8h45z" fill={`url(#${prefix}-a)`} />
      <path d="M45 .8l27 26.9v71.6H0V.8h45z" fillOpacity="0" stroke="#951b1f" strokeWidth="2" />
      <path
        d="M9.9 91.3v-20h6.5c2.5 0 4.1.1 4.8.3 1.1.3 2.1.9 2.9 2 .8 1 1.2 2.3 1.2 3.9 0 1.2-.2 2.3-.7 3.1-.4.8-1 1.5-1.7 2s-1.4.8-2.1.9c-1 .2-2.4.3-4.2.3H14v7.5H9.9zM14 74.7v5.7h2.2c1.6 0 2.7-.1 3.2-.3.5-.2 1-.5 1.3-1 .3-.4.5-1 .5-1.6 0-.7-.2-1.3-.6-1.8-.4-.5-1-.8-1.6-.9-.5-.1-1.5-.1-2.9-.1H14zm14.6-3.4H36c1.7 0 2.9.1 3.8.4 1.2.3 2.2 1 3 1.8.8.9 1.5 2 1.9 3.2.4 1.3.7 2.8.7 4.7 0 1.6-.2 3.1-.6 4.2-.5 1.5-1.2 2.6-2.1 3.5-.7.7-1.7 1.2-2.8 1.6-.9.3-2.1.4-3.6.4h-7.6V71.3zm4 3.4v13.2h3c1.1 0 1.9-.1 2.4-.2.7-.2 1.2-.4 1.6-.8.4-.4.8-1 1.1-1.9.3-.9.4-2.1.4-3.7 0-1.5-.1-2.7-.4-3.5s-.7-1.5-1.1-1.9c-.5-.5-1.1-.8-1.9-.9-.6-.1-1.7-.2-3.3-.2h-1.8zm16.2 16.6v-20h13.7v3.4h-9.7v4.7h8.4v3.4h-8.4v8.5h-4z"
        fill="#fff"
      />
      <linearGradient
        id={`${prefix}-b`}
        gradientUnits="userSpaceOnUse"
        x1="45.035"
        y1="72.356"
        x2="58.535"
        y2="85.856"
        gradientTransform="matrix(1 0 0 -1 0 100)"
      >
        <stop offset="0" stop-color="#fddfd8" />
        <stop offset=".166" stop-color="#fcdcd4" />
        <stop offset=".302" stop-color="#f9d3c9" />
        <stop offset=".427" stop-color="#f4c5b7" />
        <stop offset=".546" stop-color="#efb1a0" />
        <stop offset=".661" stop-color="#e99983" />
        <stop offset=".772" stop-color="#e27e66" />
        <stop offset=".88" stop-color="#da5c46" />
        <stop offset=".984" stop-color="#d22b2a" />
        <stop offset="1" stop-color="#d12027" />
      </linearGradient>
      <path d="M45 .8l27 26.9H45V.8z" fill={`url(#${prefix}-b)`} />
      <path
        d="M45 .8l27 26.9H45V.8z"
        fillOpacity="0"
        stroke="#8e191c"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function DocxIcon({ prefix }: { prefix: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 100" className="w-full h-full">
      <linearGradient
        id={`${prefix}-a`}
        gradientUnits="userSpaceOnUse"
        x1="36"
        y1="3.005"
        x2="36"
        y2="101"
        gradientTransform="matrix(1 0 0 -1 0 102)"
      >
        <stop offset=".005" stop-color="#002d44" />
        <stop offset=".056" stop-color="#013852" />
        <stop offset=".16" stop-color="#0a4d6b" />
        <stop offset=".274" stop-color="#0f5e82" />
        <stop offset=".398" stop-color="#0f6d96" />
        <stop offset=".539" stop-color="#0d77a4" />
        <stop offset=".711" stop-color="#0a7eae" />
        <stop offset="1" stop-color="#0881b2" />
      </linearGradient>
      <path d="M45 1l27 26.7V99H0V1h45z" fill={`url(#${prefix}-a)`} />
      <path d="M45 1l27 26.7V99H0V1h45z" fillOpacity="0" stroke="#01415e" strokeWidth="2" />
      <path
        d="M5.4 75.3h5.9c1.3 0 2.3.1 3 .3.9.3 1.7.8 2.4 1.5s1.2 1.5 1.5 2.6c.3 1 .5 2.2.5 3.7 0 1.3-.2 2.4-.5 3.4-.4 1.1-1 2.1-1.7 2.8-.6.5-1.3 1-2.3 1.3-.7.2-1.7.3-2.8.3h-6V75.3zM8.6 78v10.4H11c.9 0 1.5 0 1.9-.2.5-.1 1-.3 1.3-.7s.6-.8.8-1.5c.2-.7.3-1.7.3-2.9s-.1-2.2-.3-2.8c-.2-.7-.5-1.2-.9-1.5s-.9-.6-1.5-.7c-.3-.1-1.2-.1-2.5-.1H8.6zm12.2 5.3c0-1.6.2-3 .7-4 .4-.8.9-1.5 1.5-2.2.6-.6 1.3-1.1 2.1-1.4 1-.4 2.1-.6 3.4-.6 2.3 0 4.2.7 5.6 2.2s2.1 3.4 2.1 6c0 2.5-.7 4.5-2.1 6-1.4 1.4-3.3 2.2-5.6 2.2-2.4 0-4.2-.7-5.6-2.1-1.4-1.6-2.1-3.6-2.1-6.1zm3.3-.1c0 1.8.4 3.1 1.2 4.1.8.9 1.9 1.4 3.2 1.4 1.3 0 2.3-.5 3.2-1.4.8-.9 1.2-2.3 1.2-4.1 0-1.8-.4-3.2-1.2-4s-1.9-1.3-3.2-1.3c-1.3 0-2.4.4-3.2 1.3-.8.8-1.2 2.2-1.2 4zm24.8 2.1l3.1 1c-.5 1.7-1.3 3-2.4 3.8-1.1.8-2.5 1.3-4.2 1.3-2.1 0-3.8-.7-5.2-2.1-1.4-1.4-2-3.4-2-5.9 0-2.6.7-4.7 2.1-6.1 1.4-1.4 3.2-2.2 5.4-2.2 1.9 0 3.5.6 4.7 1.7.7.7 1.3 1.6 1.6 2.9l-3.2.8c-.2-.8-.6-1.5-1.2-1.9-.6-.5-1.3-.7-2.2-.7-1.2 0-2.1.4-2.9 1.3-.7.8-1.1 2.2-1.1 4.1 0 2 .4 3.4 1.1 4.3s1.7 1.3 2.8 1.3c.9 0 1.6-.3 2.2-.8.7-.8 1.2-1.7 1.4-2.8zm4.3 5.8l5.4-8.2-4.9-7.5h3.8l3.2 5.1 3.1-5.1h3.7l-5 7.6 5.4 8.1H64l-3.5-5.4-3.5 5.4h-3.8z"
        fill="#fff"
      />
      <linearGradient
        id={`${prefix}-c`}
        gradientUnits="userSpaceOnUse"
        x1="45.069"
        y1="74.205"
        x2="58.569"
        y2="87.705"
        gradientTransform="matrix(1 0 0 -1 0 102)"
      >
        <stop offset=".005" stop-color="#dff1fa" />
        <stop offset=".3" stop-color="#dceef7" />
        <stop offset=".443" stop-color="#d3e4ef" />
        <stop offset=".553" stop-color="#c4d6e3" />
        <stop offset=".647" stop-color="#b1c5d5" />
        <stop offset=".73" stop-color="#9ab0c5" />
        <stop offset=".805" stop-color="#819ab3" />
        <stop offset=".875" stop-color="#64829f" />
        <stop offset=".938" stop-color="#426c8c" />
        <stop offset=".998" stop-color="#06577a" />
        <stop offset="1" stop-color="#015679" />
      </linearGradient>
      <path d="M45 1l27 26.7H45V1z" fill={`url(#${prefix}-c)`} />
      <path
        d="M45 1l27 26.7H45V1z"
        fillOpacity="0"
        stroke="#01415e"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  )
}

function TxtIcon({ prefix }: { prefix: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 100" className="w-full h-full">
      <linearGradient
        id={`${prefix}-a`}
        gradientUnits="userSpaceOnUse"
        x1="36"
        y1="2.953"
        x2="36"
        y2="100.95"
        gradientTransform="matrix(1 0 0 -1 0 102)"
      >
        <stop offset="0" stop-color="#c8d4db" />
        <stop offset=".139" stop-color="#d8e1e6" />
        <stop offset=".359" stop-color="#ebf0f3" />
        <stop offset=".617" stop-color="#f9fafb" />
        <stop offset="1" stop-color="#fff" />
      </linearGradient>
      <path d="M45 1l27 26.7V99H0V1h45z" fill={`url(#${prefix}-a)`} />
      <path d="M45 1l27 26.7V99H0V1h45z" fillOpacity="0" stroke="#7191a1" strokeWidth="2" />
      <path d="M11.8 33.7h48.6v4.1H11.8v-4.1z" fill="#7291a1" />
      <path d="M11.8 46h48.6v4.1H11.8V46z" fill="#7291a1" />
      <path d="M11.8 57.8h48.6v4.1H11.8v-4.1z" fill="#7291a1" />
      <path d="M11.8 21.6h48.6v4.1H11.8v-4.1z" fill="#7291a1" />
      <linearGradient
        id={`${prefix}-b`}
        gradientUnits="userSpaceOnUse"
        x1="45.068"
        y1="74.155"
        x2="58.568"
        y2="87.655"
        gradientTransform="matrix(1 0 0 -1 0 102)"
      >
        <stop offset="0" stop-color="#fff" />
        <stop offset=".35" stop-color="#fafbfb" />
        <stop offset=".532" stop-color="#edf1f4" />
        <stop offset=".675" stop-color="#dde5e9" />
        <stop offset=".799" stop-color="#c7d3da" />
        <stop offset=".908" stop-color="#adbdc7" />
        <stop offset="1" stop-color="#92a5b0" />
      </linearGradient>
      <path d="M45 1l27 26.7H45V1z" fill={`url(#${prefix}-b)`} />
      <path
        d="M45 1l27 26.7H45V1z"
        fillOpacity="0"
        stroke="#7191a1"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  )
}

function MdIcon({ prefix }: { prefix: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 100" className="w-full h-full">
      <linearGradient
        id={`${prefix}-a`}
        gradientUnits="userSpaceOnUse"
        x1="36"
        y1=".8"
        x2="36"
        y2="98.8"
        gradientTransform="matrix(1 0 0 -1 0 100)"
      >
        <stop offset="0" stop-color="#c8d4db" />
        <stop offset=".047" stop-color="#cfd9e0" />
        <stop offset=".225" stop-color="#e4eaed" />
        <stop offset=".424" stop-color="#f3f6f7" />
        <stop offset=".655" stop-color="#fcfdfd" />
        <stop offset="1" stop-color="#fff" />
      </linearGradient>
      <path
        d="M45 1.2L72 28v71.2H0v-98h45z"
        fill={`url(#${prefix}-a)`}
        stroke="#7191a0"
        strokeWidth="2"
      />
      <path
        d="M17 92.3V72.5h6L26.7 86l3.6-13.5h6.1v19.8h-3.8V76.7l-4 15.6h-3.9l-4-15.6v15.6H17zm23.3-19.8h7.4c1.7 0 2.9.1 3.8.4 1.2.3 2.2 1 3 1.8s1.5 1.9 1.9 3.2.7 2.8.7 4.7c0 1.6-.2 3-.6 4.2-.5 1.4-1.2 2.6-2.1 3.5-.7.7-1.6 1.2-2.8 1.6-.9.3-2.1.4-3.6.4h-7.6V72.5h-.1zm4.1 3.3V89h3c1.1 0 1.9-.1 2.4-.2.7-.2 1.2-.4 1.6-.8.4-.4.8-1 1.1-1.9s.4-2.1.4-3.6-.1-2.7-.4-3.5c-.3-.8-.7-1.5-1.1-1.9s-1.1-.8-1.9-.9c-.6-.1-1.7-.2-3.3-.2h-1.8v-.2z"
        fill="#4c6c7b"
      />
      <linearGradient
        id={`${prefix}-b`}
        gradientUnits="userSpaceOnUse"
        x1="36.25"
        y1="61.9"
        x2="36.25"
        y2="23"
      >
        <stop offset="0" stop-color="#adccdc" />
        <stop offset="1" stop-color="#4c6c7b" />
      </linearGradient>
      <path
        d="M23.7 51.8h-4.1v-5.6H25l1.8-7.6h-7.3V33h8.7l2.4-10h6.8L35 33h6.7L44 23h7.1l-2.4 10H53v5.7h-5.6l-1.8 7.6H53v5.6h-8.8l-2.4 10H35l2.3-10h-6.8l-2.4 10h-6.9l2.5-10.1zm10-13.1l-1.8 7.6h6.8l1.8-7.6h-6.8z"
        opacity=".9"
        fill={`url(#${prefix}-b)`}
      />
      <linearGradient
        id={`${prefix}-c`}
        gradientUnits="userSpaceOnUse"
        x1="45.05"
        y1="71.95"
        x2="58.55"
        y2="85.45"
        gradientTransform="matrix(1 0 0 -1 0 100)"
      >
        <stop offset="0" stop-color="#fff" />
        <stop offset=".335" stop-color="#fdfdfd" />
        <stop offset=".51" stop-color="#f5f7f8" />
        <stop offset=".647" stop-color="#e7ecee" />
        <stop offset=".765" stop-color="#d4dce0" />
        <stop offset=".87" stop-color="#bcc8cf" />
        <stop offset=".966" stop-color="#9eafb9" />
        <stop offset="1" stop-color="#91a5b0" />
      </linearGradient>
      <path
        d="M45 1.2L72 28H45V1.2z"
        fill={`url(#${prefix}-c)`}
        stroke="#7191a0"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  )
}

function HtmlIcon({ prefix }: { prefix: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 100" className="w-full h-full">
      <linearGradient
        id={`${prefix}-a`}
        gradientUnits="userSpaceOnUse"
        x1="36"
        y1="97"
        x2="36"
        y2="-1"
        gradientTransform="translate(0 2)"
      >
        <stop offset="0" stop-color="#c8d4db" />
        <stop offset=".139" stop-color="#d8e1e6" />
        <stop offset=".359" stop-color="#ebf0f3" />
        <stop offset=".617" stop-color="#f9fafb" />
        <stop offset="1" stop-color="#fff" />
      </linearGradient>
      <path d="M45 1l27 26.7V99H0V1h45z" fill={`url(#${prefix}-a)`} />
      <path d="M45 1l27 26.7V99H0V1h45z" fillOpacity="0" stroke="#7191a1" strokeWidth="2" />
      <path
        d="M12 44.7l14-12.1v6.1l-9.5 7.9v.1l9.5 7.9v6.1l-14-12v-4z"
        fill="#4c6c7b"
        stroke="#4c6c7b"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M38.4 29.5h3.7l-7.2 35h-3.6l7.1-35z"
        fill="#4c6c7b"
        stroke="#4c6c7b"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M47.2 54.8l9.5-7.9v-.1l-9.5-7.9v-6.1l14 12.1V49l-14 12.1v-6.3z"
        fill="#4c6c7b"
        stroke="#4c6c7b"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <linearGradient
        id={`${prefix}-b`}
        gradientUnits="userSpaceOnUse"
        x1="45.037"
        y1="25.813"
        x2="58.537"
        y2="12.313"
        gradientTransform="translate(0 2)"
      >
        <stop offset="0" stop-color="#fff" />
        <stop offset=".35" stop-color="#fafbfb" />
        <stop offset=".532" stop-color="#edf1f4" />
        <stop offset=".675" stop-color="#dde5e9" />
        <stop offset=".799" stop-color="#c7d3da" />
        <stop offset=".908" stop-color="#adbdc7" />
        <stop offset="1" stop-color="#92a5b0" />
      </linearGradient>
      <path d="M45 1l27 26.7H45V1z" fill={`url(#${prefix}-b)`} />
      <path
        d="M45 1l27 26.7H45V1z"
        fillOpacity="0"
        stroke="#7191a1"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  )
}

function JsonIcon({ prefix }: { prefix: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 100" className="w-full h-full">
      <linearGradient
        id={`${prefix}-a`}
        gradientUnits="userSpaceOnUse"
        x1="36"
        y1="97"
        x2="36"
        y2="-1"
        gradientTransform="translate(0 2)"
      >
        <stop offset="0" stop-color="#c8d4db" />
        <stop offset=".139" stop-color="#d8e1e6" />
        <stop offset=".359" stop-color="#ebf0f3" />
        <stop offset=".617" stop-color="#f9fafb" />
        <stop offset="1" stop-color="#fff" />
      </linearGradient>
      <path d="M45 1l27 26.7V99H0V1h45z" fill={`url(#${prefix}-a)`} />
      <path d="M45 1l27 26.7V99H0V1h45z" fillOpacity="0" stroke="#7191a1" strokeWidth="2" />
      <path
        d="M14.4 44.1v-4.9c1-.1 1.8-.2 2.3-.5.5-.2.9-.7 1.3-1.2.4-.6.6-1.3.8-2.2.1-.7.2-1.8.2-3.4 0-2.7.1-4.5.4-5.6.2-1 .7-1.9 1.3-2.5s1.6-1.1 2.8-1.5c.8-.2 2.1-.4 3.9-.4h1.1v4.9c-1.5 0-2.5.1-2.9.3-.4.2-.7.4-1 .8-.2.3-.3.9-.3 1.8s-.1 2.5-.2 4.9c-.1 1.4-.2 2.5-.5 3.4-.3.8-.7 1.5-1.1 2.1-.4.5-1.1 1.1-2 1.7.8.5 1.5 1 2 1.6s.9 1.4 1.2 2.3.5 2.1.5 3.6c.1 2.3.1 3.7.1 4.4 0 .9.1 1.5.3 1.9.2.4.6.6 1 .8.4.2 1.4.3 2.9.3v4.9h-1.1c-1.8 0-3.3-.1-4.2-.4-1-.3-1.8-.8-2.5-1.5s-1.1-1.5-1.4-2.5c-.2-1-.3-2.6-.3-4.8 0-2.5-.1-4.2-.3-4.9-.3-1.1-.8-1.9-1.4-2.4-.7-.6-1.6-1-2.9-1z"
        fill="#4c6c7b"
      />
      <path
        d="M58.7 44.1c-1 .1-1.8.2-2.3.5-.5.2-.9.7-1.3 1.2-.4.6-.6 1.3-.8 2.2-.1.7-.2 1.8-.2 3.4 0 2.7-.1 4.5-.4 5.6-.2 1.1-.7 1.9-1.3 2.5-.6.6-1.6 1.1-2.8 1.5-.8.2-2.1.4-3.9.4h-1.1v-4.9c1.5 0 2.4-.1 2.9-.3s.8-.5 1-.8c.2-.3.3-.9.3-1.8 0-.8.1-2.4.2-4.8.1-1.4.3-2.6.6-3.4.3-.9.7-1.6 1.2-2.2s1.1-1.1 1.9-1.6c-1-.7-1.8-1.3-2.2-1.9-.6-.9-1.1-2.1-1.3-3.4-.2-1-.3-3.1-.3-6.3 0-1-.1-1.7-.3-2.1-.2-.3-.5-.6-.9-.8-.4-.2-1.4-.3-3-.3V22h1.1c1.8 0 3.3.1 4.2.4 1 .3 1.8.8 2.5 1.5s1.1 1.5 1.4 2.5c.2 1 .4 2.6.4 4.8 0 2.5.1 4.1.3 4.9.3 1.1.8 1.9 1.4 2.3.6.5 1.6.7 2.8.8l-.1 4.9z"
        fill="#4c6c7b"
      />
      <linearGradient
        id={`${prefix}-b`}
        gradientUnits="userSpaceOnUse"
        x1="45.037"
        y1="25.813"
        x2="58.537"
        y2="12.313"
        gradientTransform="translate(0 2)"
      >
        <stop offset="0" stop-color="#fff" />
        <stop offset=".35" stop-color="#fafbfb" />
        <stop offset=".532" stop-color="#edf1f4" />
        <stop offset=".675" stop-color="#dde5e9" />
        <stop offset=".799" stop-color="#c7d3da" />
        <stop offset=".908" stop-color="#adbdc7" />
        <stop offset="1" stop-color="#92a5b0" />
      </linearGradient>
      <path d="M45 1l27 26.7H45V1z" fill={`url(#${prefix}-b)`} />
      <path
        d="M45 1l27 26.7H45V1z"
        fillOpacity="0"
        stroke="#7191a1"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  )
}

function BlankIcon({ prefix }: { prefix: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 100" className="w-full h-full">
      <linearGradient
        id={`${prefix}-a`}
        gradientUnits="userSpaceOnUse"
        x1="36"
        y1="1"
        x2="36"
        y2="99"
        gradientTransform="matrix(1 0 0 -1 0 100)"
      >
        <stop offset="0" stop-color="#c8d4db" />
        <stop offset=".139" stop-color="#d8e1e6" />
        <stop offset=".359" stop-color="#ebf0f3" />
        <stop offset=".617" stop-color="#f9fafb" />
        <stop offset="1" stop-color="#fff" />
      </linearGradient>
      <path d="M45 1l27 26.7V99H0V1h45z" fill={`url(#${prefix}-a)`} />
      <path d="M45 1l27 26.7V99H0V1h45z" fillOpacity="0" stroke="#7191a1" strokeWidth="2" />
      <linearGradient
        id={`${prefix}-b`}
        gradientUnits="userSpaceOnUse"
        x1="45.068"
        y1="72.204"
        x2="58.568"
        y2="85.705"
        gradientTransform="matrix(1 0 0 -1 0 100)"
      >
        <stop offset="0" stop-color="#fff" />
        <stop offset=".35" stop-color="#fafbfb" />
        <stop offset=".532" stop-color="#edf1f4" />
        <stop offset=".675" stop-color="#dde5e9" />
        <stop offset=".799" stop-color="#c7d3da" />
        <stop offset=".908" stop-color="#adbdc7" />
        <stop offset="1" stop-color="#92a5b0" />
      </linearGradient>
      <path d="M45 1l27 26.7H45V1z" fill={`url(#${prefix}-b)`} />
      <path
        d="M45 1l27 26.7H45V1z"
        fillOpacity="0"
        stroke="#7191a1"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </svg>
  )
}

const ICON_COMPONENTS: Record<string, React.ComponentType<{ prefix: string }>> = {
  pdf: PdfIcon,
  docx: DocxIcon,
  doc: DocxIcon,
  txt: TxtIcon,
  md: MdIcon,
  html: HtmlIcon,
  json: JsonIcon,
}

export default function FileTypeIcon({ fileType, className = '' }: FileTypeIconProps) {
  const id = useId()
  const prefix = id.replace(/:/g, '')
  const IconComponent = ICON_COMPONENTS[fileType.toLowerCase()] ?? BlankIcon

  return (
    <div className={className} aria-label={`${fileType.toUpperCase()} file`}>
      <IconComponent prefix={prefix} />
    </div>
  )
}
